import React from 'react'
import PropTypes from 'prop-types'

const GroupIcon = (props) => {
  const { color = '#000000', classes = 'w-20' } = props

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        opacity="0.3"
        d="M7.85938 15.7076C7.94702 15.4828 7.98597 15.3265 8.74554 15.0332C9.69013 14.6618 10.6834 14.4859 11.6864 14.4859C12.6894 14.4859 13.6827 14.6618 14.6273 15.0332C15.3772 15.3265 15.4161 15.4828 15.5135 15.7076H7.85938ZM11.6864 7.88867C12.222 7.88867 12.6602 8.32849 12.6602 8.86604C12.6602 9.40359 12.222 9.84341 11.6864 9.84341C11.1508 9.84341 10.7126 9.40359 10.7126 8.86604C10.7126 8.32849 11.1508 7.88867 11.6864 7.88867Z"
        fill={color}
      />
      <path
        d="M3.89522 12.7771C4.96641 12.7771 5.84283 11.8975 5.84283 10.8224C5.84283 9.74729 4.96641 8.86765 3.89522 8.86765C2.82404 8.86765 1.94761 9.74729 1.94761 10.8224C1.94761 11.8975 2.82404 12.7771 3.89522 12.7771ZM4.99562 13.8522C4.63531 13.7936 4.275 13.7545 3.89522 13.7545C2.93115 13.7545 2.01578 13.9597 1.18804 14.3214C0.467427 14.6341 0 15.3378 0 16.1295V17.664H4.38212V16.0904C4.38212 15.2792 4.6061 14.5168 4.99562 13.8522ZM19.4761 12.7771C20.5473 12.7771 21.4237 11.8975 21.4237 10.8224C21.4237 9.74729 20.5473 8.86765 19.4761 8.86765C18.4049 8.86765 17.5285 9.74729 17.5285 10.8224C17.5285 11.8975 18.4049 12.7771 19.4761 12.7771ZM23.3713 16.1295C23.3713 15.3378 22.9039 14.6341 22.1833 14.3214C21.3555 13.9597 20.4402 13.7545 19.4761 13.7545C19.0963 13.7545 18.736 13.7936 18.3757 13.8522C18.7652 14.5168 18.9892 15.2792 18.9892 16.0904V17.664H23.3713V16.1295ZM15.8146 13.4124C14.6752 12.9042 13.273 12.5328 11.6857 12.5328C10.0984 12.5328 8.69608 12.914 7.55673 13.4124C6.50502 13.8816 5.84283 14.9371 5.84283 16.0904V17.664H17.5285V16.0904C17.5285 14.9371 16.8663 13.8816 15.8146 13.4124ZM7.85861 15.7092C7.94625 15.4844 7.9852 15.3281 8.74477 15.0349C9.68936 14.6635 10.6826 14.4875 11.6857 14.4875C12.6887 14.4875 13.682 14.6635 14.6266 15.0349C15.3764 15.3281 15.4153 15.4844 15.5127 15.7092H7.85861ZM11.6857 7.89029C12.2213 7.89029 12.6595 8.3301 12.6595 8.86765C12.6595 9.40521 12.2213 9.84502 11.6857 9.84502C11.1501 9.84502 10.7119 9.40521 10.7119 8.86765C10.7119 8.3301 11.1501 7.89029 11.6857 7.89029ZM11.6857 5.93555C10.0691 5.93555 8.76425 7.24522 8.76425 8.86765C8.76425 10.4901 10.0691 11.7998 11.6857 11.7998C13.3022 11.7998 14.6071 10.4901 14.6071 8.86765C14.6071 7.24522 13.3022 5.93555 11.6857 5.93555Z"
        fill={color}
      />
    </svg>
  )
}

GroupIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(GroupIcon)
